import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Raffles } from '../../models/lottery/raffles.models';
import { BaseService } from '../base.service';
import { ResponseModel } from '../../models/base-response.model';
import { RaffleStatus } from '../../enums/lottery.enums';

@Injectable({
  providedIn: 'root'
})
export class RafflesService extends BaseService<Raffles> {

  constructor(private _http: HttpClient) {
    super(_http, 'lottery/raffles');
  }

  getAllOpenRaffles(status:RaffleStatus = RaffleStatus.Open): Observable<ResponseModel<Raffles[]>> {
    return this._http.get<ResponseModel<Raffles[]>>(`${this.baseUrl}/today?status=${status}`);
  }

  getWinners(date:string): Observable<ResponseModel<Raffles[]>> {
    return this._http.get<ResponseModel<Raffles[]>>(`${this.baseUrl}/published-raffle?date=${date}`);
  }
}
